import LinearProgress from '@material-ui/core/LinearProgress';
import { makeStyles } from '@material-ui/core/styles';
import React, { useState, useEffect } from 'react';

import * as colors from '../../../styles/colors';

// Assumes tail is bottom center of pill and tail is x tall, 2x wide

// Adjust these for varying sizes
const pillWidth = 40;
const tailSideWidth = 4;

// DON NOT ADJUST THESE
const halfWidth = pillWidth / 2;
const halfPercentage = 50;
const negTailSideWidth = tailSideWidth * -1;
const rightTailFullPercentage = (halfWidth + tailSideWidth) / halfWidth * halfPercentage;
const rightTailEmptyPercentage = halfPercentage;
const leftTailFullPercentage = halfPercentage;
const leftTailEmptyPercentage = (halfWidth - tailSideWidth) / halfWidth * halfPercentage;
const lineSlope = tailSideWidth / (rightTailFullPercentage - halfPercentage);
const lineIntercept = -1 * lineSlope * halfPercentage;
const leftLineIntercept = lineIntercept * -1;
const leftLineSlope = lineSlope * -1;
const tailOffset = halfWidth - tailSideWidth;

const PatrolPropertyComponent = ({ count, timeRemainingPercentage = 100, color = colors.KONTRA_BLUE }) => {
  const classes = useStyles({ color, timeRemainingPercentage });
  const [ rightFill, setRightFill ] = useState();
  const [ leftFill, setLeftFill ] = useState();
  const [ timeRemaining, setTimeRemaining ] = useState(timeRemainingPercentage);

  useEffect(() => {

      // Right side of tail
      if(timeRemainingPercentage <= rightTailFullPercentage && timeRemainingPercentage > rightTailEmptyPercentage) {
        const tailVal = Math.round(lineSlope * timeRemainingPercentage + lineIntercept);
        const tailFill = Math.abs(tailVal);
        const pillFill = Math.round((tailVal - lineIntercept) / lineSlope);
        setRightFill(tailSideWidth - tailFill);
        setTimeRemaining(pillFill);
      } else if(timeRemainingPercentage > rightTailFullPercentage) {
        setRightFill(0);
      } else if(timeRemainingPercentage <= rightTailEmptyPercentage) {
        setRightFill(tailSideWidth);
      }

      // Left side of tail
      if(timeRemainingPercentage <= leftTailFullPercentage && timeRemainingPercentage > leftTailEmptyPercentage) {
        const tailVal = Math.round(leftLineSlope * timeRemainingPercentage + leftLineIntercept);
        const tailFill = Math.abs(tailVal);
        const pillFill = Math.round((tailVal - leftLineIntercept) / leftLineSlope);
        setLeftFill(tailSideWidth - tailFill);
        setTimeRemaining(pillFill);
      } 
      else if(timeRemainingPercentage > leftTailFullPercentage) {
        setLeftFill(tailSideWidth);
      } else if(timeRemainingPercentage <= leftTailEmptyPercentage) {
        setLeftFill(0);
      }

      // Pill
      if(
        timeRemainingPercentage > rightTailFullPercentage || 
        timeRemainingPercentage <= leftTailEmptyPercentage
      ) setTimeRemaining(timeRemainingPercentage);
      
    }, [timeRemainingPercentage]
  );

  return (
    <div>
      <div className={classes.pill}>
        <span className={classes.layoutText}>{count}</span>
        <div className={classes.progressContainer}>
          {timeRemainingPercentage < 100 ? (
            <LinearProgress
              className={classes.linearProgress}
              classes={{ barColorPrimary: classes.linearProgressBar }}
              value={timeRemaining}
              variant='determinate'
            />
          ) : (
            <div className={classes.fullProgressBar} />
          )}
          <div className={classes.textContainer} style={{ fontSize: count.length > 6 ? 10 : 12 }}>
            <span>{count}</span>
          </div>
        </div>
      </div>
      <div
        style={{
          width: 0,
          height: 0,
          position: 'relative',
          left: tailOffset,
          borderLeft: `${tailSideWidth}px solid transparent`,
          borderRight: `${tailSideWidth}px solid transparent`,
          borderTop: `${tailSideWidth}px solid ${color}`
        }}
      >
        <div
          style={{
            width: 0,
            height: 0,
            position: 'relative',
            top: negTailSideWidth,
            left: negTailSideWidth,
            borderLeft: `${tailSideWidth}px solid transparent`,
            borderTop: `${tailSideWidth}px solid #121212`
          }}
        />
        <div
          style={{
            width: 0,
            height: 0,
            position: 'absolute',
            top: negTailSideWidth,
            right: negTailSideWidth,
            borderRight: `${rightFill}px solid transparent`,
            borderTop: `${rightFill}px solid #121212`
          }}
        />
        <div
          style={{
            width: 0,
            height: 0,
            position: 'absolute',
            top: negTailSideWidth,
            left: negTailSideWidth,
            borderLeft: `${leftFill}px solid transparent`,
            borderTop: `${leftFill}px solid ${color}`
          }}
        />
      </div>
    </div>
  );
};

const useStyles = makeStyles(() => ({
  pill: {
    height: 20,
    width: pillWidth,
    position: 'relative',
    paddingLeft: tailSideWidth,
    paddingRight: tailSideWidth,
    borderRadius: 100,
    overflow: 'hidden'
  },
  tailFill: {
    width: 0,
    height: 0, 
    position: 'relative',
    top: negTailSideWidth,
    left: negTailSideWidth,
    borderLeft: '0px solid transparent',
    borderTop: `0px solid ${colors.KONTRA_BLUE}`
  },
  leftTailBase: {
    width: 0,
    height: 0, 
    position: 'relative',
    top: negTailSideWidth,
    left: negTailSideWidth,
    borderLeft: `${tailSideWidth}px solid transparent`,
    borderTop: `${tailSideWidth}px solid #121212`
  },
  tailBase: {
    width: 0,
    height: 0, 
    position: 'relative',
    left: tailOffset,
    borderLeft: `${tailSideWidth}px solid transparent`,
    borderRight: `${tailSideWidth}px solid transparent`,
    borderTop: `${tailSideWidth}px solid ${colors.KONTRA_BLUE}`
  },
  layoutText: {
    display: 'inline-block',
    color: 'transparent',
    fontSize: 10,
    fontWeight: 500,
    whiteSpace: 'nowrap'
  },
  progressContainer: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    top: 0
  },
  linearProgress: {
    height: '100%',
    borderRadius: 100,
    backgroundColor: '#121212'
  },
  linearProgressBar: {
    backgroundColor: props => props.color
  },
  fullProgressBar: {
    height: '100%',
    backgroundColor: props => props.color
  },
  textContainer: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    top: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 100,
    color: colors.WHITE,
    fontSize: 12,
    fontWeight: 500
  }
}));

export default PatrolPropertyComponent;